import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import get from "lodash/get";
import React from "react";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import { connect } from "react-redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { radioinputconverter } from "../../../../../../Component/DynamicForm/Fields/Radio";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import { ErrorMessages } from "../../../../../../Constants";
import daysList from "../../../../../../Constants/DATA/daysList";

const POST_DATA = {
  isfbp: null, // true,
  fbppaidtypeid: null, // 1,
  fbpcutoffday: null, // null,
  unusefbpttypeid: null, // null
};
export class FlexibleBenefitPlan extends React.Component {
  state = {
    postdata: POST_DATA,
    empList: [],
    SelectedEmpData: [],
  };

  componentDidMount() {
    console.log("Component did mount");
    this.getdata();
    this.editable();
  }

  editable = () => {
    instance
    .get("payroll/issubscriptionfbpedit")
    .then((res) => {
      this.setState({
        check: res.data.result[0],
      });
      console.log('check: ', this.state.check);
    });
  }

  getdata = () => {
    instance
      .get("payroll/fbpconfig")
      .then((resp) => {
        console.log("Response =>", this.resp);
        this.setState({
          postdata: get(resp, "data.result[0]", POST_DATA),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  submit = () => {
    const { postdata } = this.state;
    const { isfbp, fbppaidtypeid, fbpcutoffday, unusefbpttypeid } = postdata;
    if (isfbp && !fbppaidtypeid) {
      this.props.enqueueSnackbar("Please select at least one plan", { variant: "error" });
      return;
    } else if (isfbp && fbppaidtypeid == 1 && !fbpcutoffday) {
      this.props.enqueueSnackbar("Please enter cut off day", { variant: "error" });
      return;
    } else if (isfbp && fbppaidtypeid == 1 && !unusefbpttypeid) {
      this.props.enqueueSnackbar("Please select How to treat the unused benefit amount?", { variant: "error" });
      return;
    }
    instance
      .post("payroll/fbpconfig", postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.getpayrollconfig();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  };

  updatepostdata = (key, value) => {
    console.log("key, value: ", key, value);
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  };

  render() {
    const { postdata } = this.state;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Misc.FlexibleBenifitPlan.header}</title>
        </Helmet>
        <Grid container>
          <Grid md={12} xs={12} lg={12} sm={12}>
            <div>
              <div>
                <div className="margin-bottom-10">
                  <Switch disabled={(this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? false : true : true} checked={postdata.isfbp ? true : false} onChange={(val) => this.setState({ postdata: { ...POST_DATA, isfbp: val.target.checked } })} value={postdata.isfbp ? true : false} color="primary" />
                  <span> Offer flexible benefit plan to employees </span>
                </div>
              </div>

              {postdata.isfbp && (
                <div className="margin-bottom-32 padding16 width50" style={{ background: "#f7f8f8" }}>
                  <div className="small-dark-secondary margin-bottom-8">How would you like to calculate the benefit amount received by employees?</div>
                  <DynamicForm
                    fields={radioinputconverter({
                      value: postdata.fbppaidtypeid == 1,
                      label: "Calculate and pay employees each month on submission of bills before the FBP cut-off date",
                      labelclass: "small-dark-secondary t-bold margin-top-2",
                      disabled: (this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? false : true : true,
                    })}
                    onChange={() => this.updatepostdata("fbppaidtypeid", 1)}
                  />
                  <div className="margin-left-20 width50">
                    <DynamicForm fields={selectinputconverter({ disabled: (this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? postdata.fbppaidtypeid != 1 : true : true, value: postdata.fbpcutoffday, options: daysList, label: "Set cut-off day" })} onChange={(val) => this.updatepostdata("fbpcutoffday", val)} />
                  </div>
                  <div className="small-dark-secondary margin-bottom-8 margin-left-20">How to treat the unused benefit amount?</div>
                  <div className="margin-left-20">
                    <DynamicForm
                      fields={radioinputconverter({
                        value: postdata.unusefbpttypeid == 1,
                        label: "Calculate remaining amount as a taxable balancing figure (special allowance)",
                        labelclass: "margin-top-2",
                        disabled: (this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? postdata.fbppaidtypeid != 1 : true : true,
                      })}
                      onChange={() => this.updatepostdata("unusefbpttypeid", 1)}
                    />
                    <DynamicForm
                      fields={radioinputconverter({
                        value: postdata.unusefbpttypeid == 2,
                        label: "Carry forward the unused benefit amount to the next month",
                        labelclass: "margin-top-2",
                        disabled: (this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? postdata.fbppaidtypeid != 1 : true : true,
                      })}
                      onChange={() => this.updatepostdata("unusefbpttypeid", 2)}
                    />
                  </div>
                  <div>
                    <DynamicForm
                      fields={radioinputconverter({
                        value: postdata.fbppaidtypeid == 2,
                        label: "Paid every month",
                        labelclass: "small-dark-secondary t-bold margin-top-2",
                        disabled: (this.props.permissions && this.props.permissions.editable) ? this.state.check && this.state.check.editable ? false : true : true,
                      })}
                      onChange={() => this.setState({ postdata: { ...postdata, fbppaidtypeid: 2, fbpcutoffday: null, unusefbpttypeid: null } })}
                    />
                    <div className="extra-small-dark-secondary margin-bottom-16">Pay maximum benefit amount as non-taxable each month. Non-submission of bills by the end of the financial year will mark paid amount for which bills are not available as taxable</div>
                  </div>
                  {/* <div>
                    <DynamicForm
                      fields={radioinputconverter({
                        value: postdata.fbppaidtypeid == 3,
                        label: "Paid at end of year",
                        labelclass: "small-dark-secondary t-bold margin-top-2",
                      })}
                      onChange={() => this.setState({ postdata: { ...postdata, fbppaidtypeid: 3, fbpcutoffday: null, unusefbpttypeid: null } })}
                    />
                    <div className="extra-small-dark-secondary margin-bottom-16">Calculate and deduct benefit amount as non-taxable each month and pay it to employees on submission of bills at the end of the financial year.</div>
                  </div> */}
                </div>
              )}
            </div>

            <Grid container>
              <Grid item xs={12} md={6} sm={12} style={{ justifyContent: "flex-start", display: "flex" }}>
                <div className="margin-top-20">
                  {(this.props.permissions && this.props.permissions.editable) && this.state.check && this.state.check.editable && postdata.isfbp != null && (
                    <Button className="btn btn-secondary-md-blue margin-right-8" variant="contained" onClick={this.submit}>
                      Save
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FlexibleBenefitPlan);
